import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Rating,
  TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

// Icon
import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import productRatingStore from "../../store/productRatingStore";

const ProductRatingDialog = ({
  openDialog,
  setOpenDialog,
  ratingValue,
  setRatingValue,
  productID,
}) => {
  const ProductRatingStore = productRatingStore();
  const handleClose = () => {
    setOpenDialog(false);
    setReview("");
  };

  const [review, setReview] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async () => {
    if (ratingValue === null) return;

    setIsLoading(true);
    await ProductRatingStore.createProductRating({
      productID,
      rating: ratingValue,
      review,
    });
    setIsLoading(false);
    handleClose();
  };

  return (
    <Dialog open={openDialog} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Add Review</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          Your review about this product:
          <Rating
            name="order-product-rating"
            className="order-product-rating"
            icon={<StarRateRoundedIcon fontSize="inherit" />}
            emptyIcon={<StarOutlineRoundedIcon fontSize="inherit" />}
            value={ratingValue}
            onChange={(event, newValue) => {
              setRatingValue(newValue);
            }}
          />
          {!ratingValue && (
            <FormHelperText sx={{ color: "hsl(94, 59%, 35%)" }}>
              require rating *
            </FormHelperText>
          )}
        </Box>

        <TextField
          sx={{ mt: 2 }}
          multiline
          rows={2}
          id="name"
          label="Review"
          type="text"
          fullWidth
          variant="outlined"
          value={review}
          onChange={(e) => setReview(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button color="warning" onClick={handleClose}>
          Cancel
        </Button>
        <LoadingButton
          loading={isLoading}
          sx={{ color: "#171717" }}
          onClick={onSubmit}
          disabled={!ratingValue}
        >
          Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ProductRatingDialog;
